
import EmptyWalletRemove from "../../../assets/duotone/EmptyWalletRemove.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function EmptyWalletRemoveIcon({ className, dataTestid = "EmptyWalletRemoveIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <EmptyWalletRemove data-testid={dataTestid} className={classes} {...rest} />
  );
}
